module.exports = __webpack_public_path__ + "img/Cabal.55fb0ccf.svg";